import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/RO';
import { overview } from './overview/RO';
import { productInfoBox } from './productInfoBox/RO';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    dashboard,
    overview,
    productInfoBox,
};
